/*************************************************/
/* EMPLOYEE                                      */
/*************************************************/

export function employee() {

    function showTooltip(tooltip, span) {
        tooltip.style.visibility = 'visible'; // Show the tooltip
        span.classList.add("hide");
        setTimeout(() => {
            tooltip.style.visibility = 'hidden'; // Hide the tooltip after 1.5 seconds
            span.classList.remove("hide");
        }, 1500);
    }

    function copyEmailToClipboard(event) {
        const email = event.target.closest('.employee-card__email-wrapper').dataset.email;
        const tooltip = event.target.closest('.employee-card__email-wrapper').querySelector('.tooltip');
        const span = event.target.closest('.employee-card__email-wrapper').querySelector('.employee-card__email-text');
        if (!navigator.clipboard) {
            // Fallback for older browsers
            const textArea = document.createElement("textarea");
            textArea.value = email;
            textArea.style.position = "fixed"; // avoid scrolling
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            try {
                document.execCommand('copy');
                showTooltip(tooltip);

                window.dataLayer.push({
                    'event': 'email-copied',
                    'eventLabel': email
                });

            } catch (err) {
                console.error("Failed to copy email.");
            }
            document.body.removeChild(textArea);
        } else {
            navigator.clipboard.writeText(email)
                .then(() => {
                    showTooltip(tooltip, span);

                    window.dataLayer.push({
                        'event': 'email-copied',
                        'eventLabel': email
                    });
                })
                .catch(() => {
                    console.error("Failed to copy email.");
                });
        }
    }

    const init = () => {
        const emailElements = document.querySelectorAll('.employee-card__email-wrapper');

        emailElements.forEach((element) => {
            element.addEventListener('click', copyEmailToClipboard);
        });
    };

    init();
}
